import SafariBleIcon from "../../assets/icon-128.png";

const IntroSplash = () => {
    return (
        <div className='w-full h-full flex flex-col items-center justify-center gap-2'>
            <img src={SafariBleIcon} alt="Safari BLE" className="w-24 h-24 animate-pulse" />
            <h1 className="text-3xl font-bold">Safari BLE</h1>
            <p className="text-sm">Bluetooth Low Energy (BLE) Extension</p>
        </div>
    )
}

export default IntroSplash;